// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__vi4tZ","header":"LoginPage_header__gzorx","logo":"LoginPage_logo__7ahRk","content":"LoginPage_content__DFb9u","form":"LoginPage_form__gJ-YV"};